export const AccEnginecommonTrueFalseMapping = {
  "": "-----",
  true: "Yes",
  false: "No",
};
